<template>
    <div class="legal-landing">
        <h1>{{ trans.get("legal.legalDisclaimer.title") }}</h1>
        <h3>{{ trans.get("legal.legalDisclaimer.subtitle") }}</h3>
        <p><strong>{{ trans.get("legal.legalDisclaimer.text1.title") }}
                <a href="https://www.humboldtseedcompany.es"
                    >www.humboldtseedcompany.es</a
                >
                {{ trans.get("legal.legalDisclaimer.text1.title2") }}</strong
            >
        </p>
        <ul>
            <li v-html="trans.get('legal.legalDisclaimer.ul1.li1')"></li>
            <li v-html="trans.get('legal.legalDisclaimer.ul1.li2')"></li>
            <li>{{ trans.get("legal.legalDisclaimer.ul1.li3") }}</li>
            <li>{{ trans.get("legal.legalDisclaimer.ul1.li4") }}</li>
            <li v-html="trans.get('legal.legalDisclaimer.ul1.li5')"></li>
            <li v-html="trans.get('legal.legalDisclaimer.ul1.li6')"></li>
        </ul>
        <p>{{ trans.get("legal.legalDisclaimer.text2") }}</p>
        <h3>
            <strong>{{ trans.get("legal.legalDisclaimer.title2") }}</strong>
        </h3>
        <h4>
            <strong>{{ trans.get("legal.legalDisclaimer.subtitle2") }}</strong>
        </h4>
        <p>{{ trans.get("legal.legalDisclaimer.text3") }}</p>
        <h4>
            <strong>{{ trans.get("legal.legalDisclaimer.subtitle3") }}</strong>
        </h4>
        <p v-html="trans.get('legal.legalDisclaimer.text4')"></p>
        <p>{{ trans.get("legal.legalDisclaimer.text5") }}</p>
        <ul>
            <li>{{ trans.get("legal.legalDisclaimer.ul2.li1") }}</li>
            <li>{{ trans.get("legal.legalDisclaimer.ul2.li2") }}</li>
            <li>{{ trans.get("legal.legalDisclaimer.ul2.li3") }}</li>
            <li>{{ trans.get("legal.legalDisclaimer.ul2.li4") }}</li>
            <li>{{ trans.get("legal.legalDisclaimer.ul2.li5") }}</li>
        </ul>
        <p>{{ trans.get("legal.legalDisclaimer.text6") }}</p>
        <h4>
            <strong>{{ trans.get("legal.legalDisclaimer.subtitle4") }}</strong>
        </h4>
        <p>{{ trans.get("legal.legalDisclaimer.text7") }}</p>

        <h4>
            <strong>{{ trans.get("legal.legalDisclaimer.subtitle5") }}</strong>
        </h4>
        <p>{{ trans.get("legal.legalDisclaimer.text8") }}</p>

        <h4>
            <strong>{{ trans.get("legal.legalDisclaimer.subtitle6") }}</strong>
        </h4>
        <p v-html="trans.get('legal.legalDisclaimer.text9')"></p>

        <h4>
            <strong>{{ trans.get("legal.legalDisclaimer.subtitle7") }}</strong>
        </h4>
        <p v-html="trans.get('legal.legalDisclaimer.text10')"></p>
        <p>{{ trans.get("legal.legalDisclaimer.text11") }}</p>
    </div>
</template>

<script>
export default {};
</script>

